import React from 'react';

const CATEGORY_TYPE_ORDER = [
  'meal_type',
  'cuisine',
  'protein',
  'dish_type',
  'cooking_method',
  'diet',
  'convenience',
  'season',
  'other',
];

export default function RecipeCount({ total, categories, selectedCategoryIds, searchTerm }) {
  if (total === 0) return null;

  // Group selected categories by type
  const selectedByType = {};
  categories
    .filter((cat) => selectedCategoryIds.includes(cat.id))
    .forEach((cat) => {
      const type = cat.category_type || 'other';
      if (!selectedByType[type]) selectedByType[type] = [];
      selectedByType[type].push(cat.name);
    });

  // Build description with OR within types, AND across types
  const typeParts = CATEGORY_TYPE_ORDER
    .filter((type) => selectedByType[type]?.length > 0)
    .map((type) => {
      const names = selectedByType[type];
      if (names.length === 1) {
        return names[0];
      }
      // Multiple in same type: wrap in parentheses with "or"
      return `(${names.join(' or ')})`;
    });

  const parts = [];

  if (typeParts.length > 0) {
    // Join type groups with "and"
    parts.push(`in ${typeParts.join(' and ')}`);
  }

  if (searchTerm?.trim()) {
    parts.push(`containing "${searchTerm.trim()}"`);
  }

  const description = parts.length > 0 ? ` ${parts.join(' ')}` : '';

  return (
    <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 leading-relaxed">
      {total} recipe{total !== 1 ? 's' : ''}{description}
    </p>
  );
}
